import config from 'config';
import { getAiAuthorizationClaims, getAiHereHeaders } from './aiChatAuthHelpers';

const {
  cognitiveLayer: {
    api: { dev: devUrl },
    endpoints: {
      aiWorkspace: { chat },
    },
  },
} = config;
export const SSE_EVENT_TYPES = {
  MESSAGE_CHUNK: 'message.chunk',
  MESSAGE_COMPLETE: 'message.complete',
  SUBAGENT_INVOKED: 'subagent.invoked',
  SUBAGENT_COMPLETED: 'subagent.completed',
  AGENT_MODEL_START: 'agent.model.start',
  TOOL_CALLED: 'tool.called',
  UPDATE_CANVAS_COMPLETED: 'update_canvas.completed',
  BUILD_SCHEMA_COMPLETED: 'build_schema.completed',
  JSON_TOOL_COMPLETED: 'json_tool.completed',
  TASK_CREATED: 'task.created',
  TASK_PROGRESS: 'task.progress',
  TASK_COMPLETED: 'task.completed',
  TASK_FAILED: 'task.failed',
  ERROR_SYSTEM: 'error.system',
  CAP_FIRED: 'cap.fired',
};

export const parseFrame = (raw) => {
  const lines = raw.split('\n');
  let type = null;
  let dataLine = null;

  lines.forEach((line) => {
    if (line.startsWith('event:')) type = line.slice(6).trim();
    if (line.startsWith('data:')) dataLine = line.slice(5).trim();
  });

  if (!type || !dataLine) return null;

  try {
    return { type, payload: JSON.parse(dataLine) };
  } catch {
    return null;
  }
};

export const streamChatMessage = async ({ message, workspaceId, onEvent, signal }) => {
  if (!workspaceId) {
    const error = new Error('Workspace ID is required');
    error.code = 'WORKSPACE_ID_REQUIRED';
    throw error;
  }

  const chatUrl = chat.replace('{workspaceId}', workspaceId);

  const response = await fetch(`${devUrl}${chatUrl}?apiKey=${process.env.REACT_APP_TP_API_KEY_DEV}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'authorization-claims': getAiAuthorizationClaims(),
      ...getAiHereHeaders(),
    },
    body: JSON.stringify({ message }),
    signal,
  });

  if (!response.ok) {
    const error = new Error('Chat request failed');
    error.status = response.status;
    throw error;
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  const processBuffer = () => {
    let boundary = buffer.indexOf('\n\n');
    while (boundary !== -1) {
      const frame = buffer.slice(0, boundary);
      buffer = buffer.slice(boundary + 2);
      const parsed = parseFrame(frame);
      if (parsed) onEvent(parsed);
      boundary = buffer.indexOf('\n\n');
    }
  };

  try {
    let result = await reader.read();
    while (!result.done) {
      buffer += decoder.decode(result.value, { stream: true });
      processBuffer();
      // eslint-disable-next-line no-await-in-loop -- sequential reads are intentional for streaming
      result = await reader.read();
    }
    if (buffer.trim()) {
      const parsed = parseFrame(buffer);
      if (parsed) onEvent(parsed);
    }
  } finally {
    reader.cancel();
  }
};
